<template>
  <div class="recommend">
    <div v-for="(item, index) in recommendList" :class="['card-item']" :key="index + 'card-item'" :style="{zIndex: index === nowIndex ? 3 : 1}" @mousemove="handleMouseMove(index)" @mouseleave="handleMouseLeave">
      <i :class="['iconfont', recommendIcon(item.profession_id)]"></i>
      <p class="name">{{item.profession_name}}</p>
      <div class="type">{{index | recommendText}}</div>
      <transition name="fade">
        <mini-user-box v-if="index === nowIndex && recommendList[index].recommendUsers.length > 0" :data="recommendList[index]" :user="recommendList[index].recommendUsers" :type-name="recommendList[index].profession_name"/>
      </transition>
    </div>
    <div :class="['card-item']">
      <img :src="resumeDetail.profile.avatar_url || 'https://files.wondercv.com/PC/editor/planning/me.png'" width="46" height="46"/>
      <p class="name">{{resumeDetail.profile.username || '超级简历用户'}}</p>
      <p class="education">{{resumeDetail.profile.degree}} {{resumeDetail.edus.length > 0 ? ((resumeDetail.profile.degree ? ' · ' : '') + resumeDetail.edus[0].major ): ''}}</p>
    </div>
    <div class="job-card">
      <div class="job-info">
        <div class="optimum-desc">
          <img  src="https://files.wondercv.com/pc/planning/optimum.png" width="16" height="16"/>
          <span>本命职位</span>
        </div>
        <div class="optimum-post">
          {{recommendList[0].profession_name}}
        </div>
      </div>
      <div class="other-box">
        <div class="correlation-expand-box">
          <img src="https://files.wondercv.com/pc/planning/correlation.png"/>
          <span>可胜任职位</span>
          <div v-for="(item, index) in recommendList.slice(1,4)" :key="index + 'profession_name'">{{item.profession_name}}</div>
        </div>
        <div class="correlation-expand-box">
          <img src="https://files.wondercv.com/pc/planning/expand.png"/>
          <span>可尝试职位</span>
          <div v-for="(item, index) in recommendList.slice(4)" :key="index + 'profession_name'">{{item.profession_name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MiniUserBox from "./mini-user"
  import {mapMutations, mapState} from "vuex"
  const Icon = {
    '10': 'iconjinrong',
    '20': 'iconzhuanyefuwu',
    '30': 'iconchanpin',
    '40': 'iconyunying',
    '50': 'iconshichanggongguan',
    '60': 'iconjishu',
    '70': 'iconsheji',
    '80': 'iconrenshihangzheng',
    '90': 'iconxiaoshou',
    '11': 'iconchuanmei',
    '12': 'iconjiaoyu',
    '13': 'iconjiankangyiliao',
    '14': 'iconjianzhudichan',
    '15': 'iconlvyou',
    '16': 'iconfuwuye',
    '17': 'iconqiche',
    '18': 'iconshengchanzhizao'
  }
  export default {
    name: "recommend-box",
    props: {
      recommendList: {
        type: Array,
        default: () => []
      }
    },
    components:{
      MiniUserBox
    },
    data(){
     return{
       nowIndex: -1
     }
    },
    computed:{
      ...mapState('planning', ['layerState', 'resumeDetail'])
    },
    mounted() {
      setTimeout(() => {
        let list = document.querySelectorAll(".card-item")

        Array.from(list).forEach((item, index) => {
          item.className = `card-item card-item${index + 1}`
        })
        document.querySelector(".job-card").style.opacity = 1
      }, 0)
    },
    methods: {
      ...mapMutations('planning', ['updateLayerState']),
      handleMouseMove(index){
        if(index === 6 || this.layerState) return;
        this.nowIndex = index
        this.updateLayerState(true)
      },
      handleMouseLeave(e){
        this.updateLayerState(false)
        this.nowIndex = -1
      },
      recommendIcon(id){
        let subId = id.toString().substr(0,2);
        return Icon[subId]
      }
    },
    filters:{
      recommendText: function (index) {
        if(index === 0 ){
          return  '本命职位';
        }else if(index === 1 || index === 2 || index === 3){
          return '可胜任职位'
        }else {
          return  '可尝试职位'
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.recommend{
  margin-left: 169px;
  position: relative;
  .card-item{
    width: 180px;
    height: 180px;
    background-image: url("https://files.wondercv.com/pc/planning/recommend-card.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: center;
    position: absolute;
    z-index: 1;
    transform: scale(0);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    /*background-color: red;*/
    border-radius: 50%;
    & > img{
      border-radius: 50%;
      margin-bottom: 14px;
      object-fit: cover;
    }
    .education{
      font-size: 12px;
      font-weight: 300;
      color: #FFFFFF;
      line-height: 12px;
      text-align: center;
      width: 100px;
      margin: 0px auto;
      overflow:hidden; //超出的文本隐藏
      text-overflow:ellipsis; //溢出用省略号显示
      white-space:nowrap;
    }
    .iconfont{
      color: #FFFFFF;
      font-size: 46px;
      margin-bottom: 14px;
    }
    .name{
      font-size: 17px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 24px;
      margin-bottom: 6px;
      width: 130px;
      text-align: center;
      overflow:hidden; //超出的文本隐藏
      text-overflow:ellipsis; //溢出用省略号显示
      white-space:nowrap;
    }
    .type{
      width: 64px;
      height: 20px;
      border-radius: 10px;
      border: 1px solid rgba(255, 255, 255, 0.3);
      line-height: 20px;
      box-sizing: border-box;
      text-align: center;
      color: rgba(255, 255, 255, 1);
      font-size: 12px;
    }
    &.card-item1{
      left: 170px;
      top: 12px;
      transform: scale(1);
      transition: transform 0.2s cubic-bezier(.01,.95,.86,1.37) 0.2s;
    }
    &.card-item2{
      left: 316px;
      top: 97px;
      transform: scale(1);
      transition: transform 0.2s cubic-bezier(.01,.95,.86,1.37) 0.4s;
    }
    &.card-item3{
      left: 316px;
      top: 265px;
      transform: scale(1);
      transition: transform 0.2s cubic-bezier(.01,.95,.86,1.37) 0.6s;
    }
    &.card-item4{
      left: 170px;
      top: 349px;
      transform: scale(1);
      transition: transform 0.2s cubic-bezier(.01,.95,.86,1.37) 0.8s;
    }
    &.card-item5{
      left: 24px;
      top: 265px;
      transform: scale(1);
      transition: transform 0.2s cubic-bezier(.01,.95,.86,1.37) 1s;
    }
    &.card-item6{
      left: 24px;
      top: 97px;
      transform: scale(1);
      transition: transform 0.2s cubic-bezier(.01,.95,.86,1.37) 1.2s;
    }
    &.card-item7{
      left: 170px;
      top: 181px;
      transition: transform 0.3s cubic-bezier(.01,.95,.86,1.37);
      transform: scale(1);
    }
  }
  .job-card{
    position: absolute;
    top: 559px;
    width: 793px;
    height: 107px;
    box-shadow: 0px 2px 48px 0px rgba(25, 28, 36, 0.5);
    border-radius: 8px;
    background-image: url("https://files.wondercv.com/pc/planning/job-card.png");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    opacity: 0;
    z-index: 1;
    transition: opacity 0.5s linear 1.4s;
    left: -137px;
    .job-info{
      width: 186px;
      height: 105px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      padding: 0 24px;
      box-sizing: border-box;
      .optimum-desc{
        display: flex;
        align-items: center;
        margin-bottom: 11px;
        & >img{
          margin-right: 10px;
        }
        & > span{
          font-size: 14px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 20px;
        }
      }
      .optimum-post{
        height: 28px;
        border-radius: 14px;
        border: 1px solid rgba(255, 255, 255, 0.3);
        box-sizing: border-box;
        text-align: center;
        line-height: 28px;
        font-size: 14px;
        font-weight: 300;
        color: #FFFFFF;
        padding: 0 16px;
      }
    }
    .other-box{
      flex: 1;
      height: 107px;
      padding: 20px 32px;
      box-sizing: border-box;
      .correlation-expand-box{
        display: flex;
        align-items: center;
        margin-bottom: 7px;
        & > img{
          width: 16px;
          height: 16px;
          margin-right: 10px;
        }
        &>span{
          font-size: 14px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 20px;
          margin-right: 16px;
        }
        & > div{
          height: 28px;
          border-radius: 14px;
          border: 1px solid rgba(255, 255, 255, 0.3);
          padding: 0 12px;
          box-sizing: border-box;
          line-height: 28px;
          font-size: 14px;
          font-weight: 300;
          color: #FFFFFF;
          margin-right: 12px;
          max-width: 136px;
          overflow:hidden; //超出的文本隐藏
          text-overflow:ellipsis; //溢出用省略号显示
          white-space:nowrap;
        }
      }
    }
  }
  .layer{
    width: 519px;
    height: 541px;
    /*background: rgba(42, 45, 54, .5);*/
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
</style>
